module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('strong', [_vm._v("SHAPE UP")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Anyone can learn to design cartoon characters by simply remembering the three most basic shapes: the circle, the square, and the triangle. All subjects can be broken down into variations of these three shapes—and once you give "), _c('em', [_vm._v("form,")]), _vm._v(" or dimension, to those shapes, you’ll have objects that seem to bounce right off the page. Try combining different shapes to see what new forms you can create!")]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("TAKING SHAPE")]), _vm._v(" The triangle, the circle, and the square are the basic building blocks of all cartoon drawings. Combine variations of these three shapes to design and give life to your creations!")]), _vm._v(" "), _c('p', {
    staticClass: "h3a"
  }, [_c('strong', [_vm._v("CREATING 3-D FORMS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first thing we need to do with the three basic shapes is to think of them as forms: real objects in three dimensions, with solidity, depth, and weight. If you treat these shapes as real forms in space, the drawings you make from them will also have the appearance of being real. This is a basic example of using "), _c('em', [_vm._v("perspective,")]), _vm._v(" or the representation of objects in three-dimensional space.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In addition to using the rules of perspective, shading your objects with varying values—from black through various grays to white—will give the shape form, or the appearance of three dimensions. (Imagine the shapes you draw as objects that can be lifted off the page and carried away!)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0004-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0004-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Triangle shape becomes cone form")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Circle shape becomes sphere form")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Square shape becomes cube form")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-07.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Sphere + cone = teardrop")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-08.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Sphere + cube = cylinder")])]), _vm._v(" "), _c('p', {
    staticClass: "h3r"
  }, [_c('strong', [_vm._v("ADDING IT UP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("You can create numerous forms by combining two or more shapes. Here two spheres can make a bean, pear, pickle, or egg shape!")])]), _vm._v(" "), _c('p', {
    staticClass: "image5"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-09.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "h3p"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("PUTTING IT ALL TOGETHER")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("The four most-used shapes in designing cartoon characters are the sphere (or ball or egg shape), the teardrop, the bean (or pear shape), and the cylinder. Create a head, hands, and feet out of a sphere; construct a torso with the teardrop or the bean shape; and fashion legs and arms using cylinders. Drawing cartoon characters is a little like building your own Frankenstein—you can collect different parts and build on them to make a whole!")]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Sphere")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Teardrop")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Bean")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('strong', [_vm._v("Cylinder")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("STEP 1 To draw this little darling, start with a ball-shaped head and a bean-shaped body. Use tapered cylinders for the arms and legs, and create ball shapes for the hands and feet. The guidelines help establish the pose and will help you place the features.")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("STEP 2 Once the basic forms are drawn, add the hair, face, clothing, and hands. Notice how these features are wrapped around the forms of her body. For example, the waistline of her dress follows the form of her bean-shaped body, and the tops of her socks follow the roundness of her cylindrical legs.")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("STEP 3 After gently erasing your guidelines with a kneaded eraser, you can clean up the drawing by going over the lines you want to keep with a pencil.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0005-08.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("STEP 4 Or you can clean up your drawing with ink for a slick finish!")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0005-09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("STEP 1 To draw this grumpy guy, start with a bean-shaped head and an egg-shaped ear. Then add a bigger bean shape for the body. Create a long teardrop shape for the sleeve and a ball for the hand. Use cylinders that taper at the ends for legs and sideways teardrop shapes for feet.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0005-10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("STEP 2 Draw a light guideline down the middle of the face, and then add a sideways teardrop shape for the nose. Rough in the rest of the face, and start to add the clothing around his portly form. Notice the way the jacket seems to wrap around his body, and the center of the jacket lines up with the guidelines!")])]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("STEP 3 Erase the guidelines, add some final details, and he’s ready to have a grumbly day!")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0005-12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_c('strong', [_vm._v("STEP 4 Or give him the brush-and-ink treatment to add more impact!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f37e6cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 66
// module chunks = 0